import { render } from "./PracticeSelector.vue?vue&type=template&id=12115bd8&scoped=true"
import script from "./PracticeSelector.vue?vue&type=script&lang=js"
export * from "./PracticeSelector.vue?vue&type=script&lang=js"

import "./PracticeSelector.vue?vue&type=style&index=0&id=12115bd8&scoped=true&lang=css"

import exportComponent from "/Users/jipfens/Library/Mobile Documents/com~apple~CloudDocs/iProjects/lexis/lexis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12115bd8"]])

export default __exports__